/* eslint no-undef:0 */

import sparkMD5 from 'spark-md5';

export default function( $ ) {
  const post_protection = window.post_protection;
  if ( typeof post_protection !== 'undefined' && post_protection.has_password === true ) {
    const $pwProtection = $( '#pw_protection' );
    if ( $pwProtection.length > 0 ) {
      $pwProtection.find('form').on( 'submit', ( e ) => {
        e.preventDefault();
        const pw = $pwProtection.find( '#post_pw_field' ).val();
        if ( sparkMD5.hash( pw + '|utopia_secret' ) === post_protection.post_password ) {
            // Selektiere alle Elemente mit der Klasse "slider", die auch Slick-Slider sind
            var slickSliders = $('.slider.slick-initialized');

            // Funktion zum Neu-Rendern der Slider
            slickSliders.each(function () {
              var currentOptions = {
                dots: !!$(this).slick('slickGetOption', 'dots'),
                infinite: !!$(this).slick('slickGetOption', 'infinite'),
                speed: $(this).slick('slickGetOption', 'speed'),
                slidesToShow: $(this).slick('slickGetOption', 'slidesToShow'),
                slidesToScroll: $(this).slick('slickGetOption', 'slidesToScroll'),
                responsive: !!$(this).slick('slickGetOption', 'responsive'),
                asNavFor: $(this).slick('slickGetOption', 'asNavFor'),
                centerMode: $(this).slick('slickGetOption', 'centerMode'),
                focusOnSelect: !!$(this).slick('slickGetOption', 'focusOnSelect'),
                arrows: !!$(this).slick('slickGetOption', 'arrows'),
                autoplay: !!$(this).slick('slickGetOption', 'autoplay'),
              }

              $(this).slick('unslick'); // Zuerst den Slider entfernen
              $(this).slick(currentOptions); // Dann den Slider erneut initialisieren
            });

          $( '.pw_protected' ).removeClass( 'pw_protected' );
        } else {
          $pwProtection.find('.error').html( 'Das Passwort ist leider nicht korrekt.' );
        }

        return false;
      } );
      $pwProtection.find('#post_pw_field').on('focus', (e)=>{
        $(e.currentTarget).val('');
        $pwProtection.find('.error').html('');
      });
      $pwProtection.find('#post_pw_field').on('keydown', ()=>{
        $pwProtection.find('.error').html('');
      });
    }
  }
}
